import * as directives from "./directives";

export default {
    install (Vue) {
        for(let obj in directives){
            Vue.directive(obj, directives[obj]);
        }

        // Vue.directive("dropdown-item",{
        //     mounted(el, binding) {
        //         console.log('el',el);
        //     },
        //     updated(el, binding) {
        //         console.log('el',el);
        //     }
        // });
    }
};
